import { useContext } from 'react';

import AppContext from '../context/Context';
import { logEvent } from '../helpers/logger';

import { useAuthContext } from './useAuthContext';

export const useLogout = () => {
  const { setConfig } = useContext(AppContext);
  const { dispatch } = useAuthContext();

  const logout = () => {
    logEvent('log_out');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setConfig('verifyUser', null);
    dispatch({ type: 'LOGOUT' });
    window.location = '/';
  };

  return { logout };
};
